import { Select } from 'src/components/Antd/Select';
import React from 'react';
import { Form } from 'src/components/Antd';
import CommonRadioMulSelect from '../CommonRadioMulSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum ESalesChannelRadioType {
  FROM_ANY_SELECTED = 'FROM_ANY_SELECTED',
  NOT_FROM_ANY_SELECTED = 'NOT_FROM_ANY_SELECTED',
}
const Item = Form.Item;
const Option = Select.Option;

const RegisteredSalesChannel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { noStyle, name, rules, options, radioName, disabled } = props;

  return (
    <React.Fragment>
      {radioName ? (
        <CommonRadioMulSelect
          disabled={disabled}
          selectPlaceholder={getI18n(
            'customerTag.tagCondition.searchandselect',
          )}
          triggerName={[
            ESalesChannelRadioType.FROM_ANY_SELECTED,
            ESalesChannelRadioType.NOT_FROM_ANY_SELECTED,
          ]}
          radioOptions={[
            {
              value: ESalesChannelRadioType.FROM_ANY_SELECTED,
              label: getI18n('customerList.registeredSalesChannel.anyOfSelect'),
            },
            {
              value: ESalesChannelRadioType.NOT_FROM_ANY_SELECTED,
              label: getI18n(
                'customerList.registeredSalesChannel.notAnyOfSelect',
              ),
            },
          ]}
          selectOptions={options}
          radioName={radioName}
          selectName={name}
          noStyle={noStyle}
        />
      ) : (
        <Item
          noStyle={noStyle}
          name={name}
          rules={
            rules ||
            [
              // {
              //   required: true,
              //   message: 'Please select at least one sales channel',
              // },
            ]
          }>
          <Select
            mode='multiple'
            size='large'
            disabled={disabled}
            getPopupContainer={() => document.body}>
            {(options || []).map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </Select>
        </Item>
      )}
    </React.Fragment>
  );
};
export default RegisteredSalesChannel;
